import React, { useCallback } from 'react';
import isNumber from 'lodash/isNumber';
import { DisclaimerText } from '@yme/atoms/disclaimer-text';
import { Col, Row } from '@yme/atoms/grid';
import { Image as ImageAtom } from '@yme/atoms/image';
import { IndentWrapper } from '@yme/components/Separator';
import { useWindowSize } from '@yme/hooks/index';
import { HeroSectionYoutube } from '@yme/molecules/hero-section-youtube';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { scrollToId } from '@yme/utils/common';
import { AspectRatio } from '@yme/utils/constants';
import { ContentDefaultView, ContentMobileView } from './components';
import { HeroBannerStyled, HeroContentWrapperStyled, HeroSectionContainerStyled, ImageBgStyled, ImageMaskStyled, } from './styled';
export function HeroSectionLandingPage(props) {
    const { 
    // Props from AEM
    title, subtitle, description, disclaimer, image, youtubeId, startTime, 
    // Common Props
    isRightToLeft, showLessLabel, showMoreLabel, learnMoreLabel, 
    // Specific Component Props
    customAspectRatio = AspectRatio.RectangleLevel3, scrollToComponentId, brandedColor, yOffset, isRemoveBottomIndent, } = props;
    const { isMobileView, isInfiniteDesktopView } = useWindowSize();
    const pbDesktop = scrollToComponentId ? '96px' : '48px';
    const isVideoShowed = isInfiniteDesktopView && youtubeId;
    const onScrollToIdHandler = useCallback((e) => {
        const hasNodeToScrollTo = scrollToComponentId && document.getElementById(scrollToComponentId);
        if (hasNodeToScrollTo && scrollToComponentId && isNumber(yOffset)) {
            scrollToId({
                id: scrollToComponentId,
                yOffset,
            });
        }
        else {
            // in this case we need to scroll to title of next section, see B2C-20818 for details
            const parentSection = e.currentTarget.closest('section');
            if (!parentSection) {
                return;
            }
            const allSections = document.querySelectorAll('section');
            const nexSection = Array.from(allSections).find((section) => section.offsetTop > parentSection.offsetTop);
            if (!nexSection) {
                return;
            }
            const nextSectionTitle = nexSection?.querySelector('h2');
            if (!nextSectionTitle) {
                return;
            }
            const fallbackId = nextSectionTitle.id || `el-${Math.random().toString(36).substr(2, 9)}`;
            if (!nextSectionTitle.id) {
                nextSectionTitle.setAttribute('id', fallbackId);
            }
            scrollToId({
                id: fallbackId,
                yOffset,
            });
        }
    }, [scrollToComponentId, yOffset]);
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(HeroBannerStyled, { isRightToLeft: isRightToLeft, aspectRatio: customAspectRatio },
            isVideoShowed ? (React.createElement(HeroSectionYoutube, { videoId: youtubeId, preview: image.src, startTime: startTime })) : (React.createElement(ImageBgStyled, null,
                React.createElement(ImageAtom, { ...image, loading: null }),
                React.createElement(ImageMaskStyled, null))),
            React.createElement(HeroContentWrapperStyled, null,
                React.createElement(FlexWrapper, { flexDirection: "column", height: "100%", pb: "16px", pbDesktop: pbDesktop },
                    React.createElement(HeroSectionContainerStyled, { aspectRatio: customAspectRatio },
                        React.createElement(Row, { mt: "auto" },
                            React.createElement(Col, { lg: 6 },
                                React.createElement(ContentDefaultView, { isRightToLeft: isRightToLeft, title: title, subtitle: subtitle, description: description, learnMoreLabel: learnMoreLabel, onClickHandler: onScrollToIdHandler, showLessLabel: showLessLabel, showMoreLabel: showMoreLabel, scrollToComponentId: scrollToComponentId }))),
                        !isMobileView && disclaimer && (React.createElement(Row, null,
                            React.createElement(Col, null,
                                React.createElement(FlexWrapper, { mtTablet: "16px", mtDesktop: "24px" },
                                    React.createElement(DisclaimerText, { disclaimerText: disclaimer }))))))))),
        isMobileView && (React.createElement(ContentMobileView, { isRightToLeft: isRightToLeft, description: description, disclaimer: disclaimer, brandedColor: brandedColor, showLessLabel: showLessLabel, showMoreLabel: showMoreLabel, learnMoreLabel: learnMoreLabel, onClickHandler: onScrollToIdHandler }))));
}
HeroSectionLandingPage.displayName = 'HeroSectionLandingPage_Organism';
